// DO NOT EDIT!!! This file is auto-generated.

export const LOCALES_SUPPORTED = [
  'de',
  'en',
  'es',
  'fi',
  'fr',
  'it',
  'ja',
] as const;
export const LOCALE_DEFAULT: LocaleSupported = 'en';

export async function getMessagesForLocale(
  locale: LocaleSupported = LOCALE_DEFAULT,
): Promise<LocaleMessagesJson> {
  switch (locale) {
    case 'de':
      return import('./locale/de.json');
    case 'en':
      return import('./locale/en.json');
    case 'es':
      return import('./locale/es.json');
    case 'fi':
      return import('./locale/fi.json');
    case 'fr':
      return import('./locale/fr.json');
    case 'it':
      return import('./locale/it.json');
    case 'ja':
      return import('./locale/ja.json');

    default:
      throw new Error('Language not supported');
  }
}

export type LocaleSupported = (typeof LOCALES_SUPPORTED)[number];

export type MessageKey =
  | 'accessibility'
  | 'account_setup_accept_health_data_checkbox'
  | 'account_setup_bullet1'
  | 'account_setup_bullet2'
  | 'account_setup_bullet3'
  | 'account_setup_bullet4'
  | 'account_setup_updated_terms_text'
  | 'chatbot_access_request_access_granted_text'
  | 'chatbot_access_request_access_granted_title'
  | 'chatbot_access_request_button'
  | 'chatbot_access_request_disclaimer'
  | 'chatbot_access_request_link_expired_text'
  | 'chatbot_access_request_link_expired_title'
  | 'chatbot_access_request_paragraph'
  | 'chatbot_access_request_paragraph_2'
  | 'chatbot_access_request_title'
  | 'circles_invite_discount'
  | 'circles_invite_get_ring_button'
  | 'circles_invite_intro'
  | 'circles_invite_member_instructions'
  | 'circles_invite_no_oura_ring'
  | 'circles_invite_status_expired'
  | 'circles_invite_status_invalid'
  | 'circles_invite_status_used'
  | 'circles_invite_title'
  | 'coaches_add_coach_email_validation'
  | 'dashboard_no_active_data_available'
  | 'dashboard_overview_next_day'
  | 'dashboard_overview_previous_day'
  | 'dashboard_section_heading_activity_and_calories'
  | 'dashboard_section_heading_activity_durations'
  | 'dashboard_section_heading_activity_intensity'
  | 'dashboard_section_heading_body_measurements'
  | 'dashboard_section_heading_hr_variability'
  | 'dashboard_section_heading_resting_hr'
  | 'dashboard_section_heading_sleep_stages'
  | 'dashboard_sleep_no_score'
  | 'daytime_heart_rate_range'
  | 'daytime_heart_rate_single_value'
  | 'deep_link_instructions'
  | 'deep_link_title'
  | 'email_verification_login_link'
  | 'email_verification_success_subtitle'
  | 'email_verification_success_title'
  | 'footer_copyright'
  | 'footer_trademark'
  | 'general_abbreviation_body_temperature'
  | 'general_abbreviation_deep_sleep'
  | 'general_abbreviation_inactive_time'
  | 'general_abbreviation_midpoint'
  | 'general_abbreviation_rem_sleep'
  | 'general_abbreviation_sleep_efficiency'
  | 'general_abbreviation_sleep_latency'
  | 'general_abbreviation_sleep_timing'
  | 'general_abbreviation_sleep_total'
  | 'general_abbreviation_total_sleep_time'
  | 'general_activity_balance'
  | 'general_activity_burn'
  | 'general_activity_score'
  | 'general_activity_score_inactive_time'
  | 'general_activity_score_meet_daily_targets'
  | 'general_activity_score_move_every_hour'
  | 'general_activity_score_recovery_time'
  | 'general_activity_score_training_frequency'
  | 'general_activity_score_training_volume'
  | 'general_average_hr'
  | 'general_average_hrv'
  | 'general_average_met'
  | 'general_average_resting_hr'
  | 'general_awake_time'
  | 'general_bedtime'
  | 'general_cancel'
  | 'general_confirm_password_fieldtext'
  | 'general_daily'
  | 'general_daily_spo2_spo2_average'
  | 'general_date'
  | 'general_deep_sleep'
  | 'general_email_fieldtext'
  | 'general_error'
  | 'general_forgot_password_link'
  | 'general_forgot_password_text_with_hub_link'
  | 'general_form_error_email_in_use'
  | 'general_form_error_invalid_credentials'
  | 'general_form_error_invalid_email'
  | 'general_form_error_invalid_token'
  | 'general_form_error_invitation_already_accepted'
  | 'general_form_error_password_too_weak'
  | 'general_form_error_token_expired'
  | 'general_heart_rate'
  | 'general_heart_rate_daytime'
  | 'general_heart_rate_error_loading_data'
  | 'general_heart_rate_sleeping_range'
  | 'general_high_activity'
  | 'general_hrv_balance'
  | 'general_inactive_time'
  | 'general_invalid_email'
  | 'general_invalid_link_text'
  | 'general_invalid_link_title'
  | 'general_light_sleep'
  | 'general_loading'
  | 'general_long_periods_of_inactivity'
  | 'general_low_activity'
  | 'general_lowest_resting_hr'
  | 'general_medium_activity'
  | 'general_meet_daily_targets'
  | 'general_month'
  | 'general_monthly'
  | 'general_move_every_hour'
  | 'general_non_wear_time'
  | 'general_password_fieldtext'
  | 'general_previous_day_activity'
  | 'general_previous_night'
  | 'general_readiness_score'
  | 'general_readiness_score_activity_balance'
  | 'general_readiness_score_hrv_balance'
  | 'general_readiness_score_previous_day_activity'
  | 'general_readiness_score_previous_night'
  | 'general_readiness_score_recovery_index'
  | 'general_readiness_score_resting_heart_rate'
  | 'general_readiness_score_sleep_balance'
  | 'general_readiness_score_temperature'
  | 'general_recovery_index'
  | 'general_recovery_time'
  | 'general_rem_sleep'
  | 'general_respiratory_rate'
  | 'general_resting_heart_rate'
  | 'general_resting_time'
  | 'general_restless_sleep'
  | 'general_sleep_balance'
  | 'general_sleep_efficiency'
  | 'general_sleep_latency'
  | 'general_sleep_restfulness'
  | 'general_sleep_score'
  | 'general_sleep_score_deep'
  | 'general_sleep_score_efficiency'
  | 'general_sleep_score_latency'
  | 'general_sleep_score_rem'
  | 'general_sleep_score_restfulness'
  | 'general_sleep_score_timing'
  | 'general_sleep_score_total'
  | 'general_sleep_timing'
  | 'general_steps'
  | 'general_target_burn'
  | 'general_temperature_deviation'
  | 'general_temperature_trend_deviation'
  | 'general_time_in_bed'
  | 'general_total_burn'
  | 'general_training_frequency'
  | 'general_training_volume'
  | 'general_wake_up_time'
  | 'general_walking_equivalency'
  | 'general_weekly'
  | 'general_year'
  | 'guide_infotext_sleep_score'
  | 'intellectual_property_notice'
  | 'login_submit_button'
  | 'login_text'
  | 'login_title'
  | 'metric_unit.alerts'
  | 'metric_unit.average_metabolic_equivalents'
  | 'metric_unit.bpm'
  | 'metric_unit.cal'
  | 'metric_unit.duration_hour_minute'
  | 'metric_unit.duration_minute'
  | 'metric_unit.per_minute'
  | 'my_account_page_main_title'
  | 'my_account_policies_text'
  | 'my_account_support_access_rights_column_header_authorized_account'
  | 'my_account_support_access_rights_column_header_expiration'
  | 'my_account_support_access_rights_revoke'
  | 'my_account_support_access_rights_revoke_confirmation'
  | 'my_account_support_access_rights_revoke_modal_title'
  | 'my_account_title_policies'
  | 'my_account_title_support_access_rights'
  | 'organization_subscription_banner_review_subscription'
  | 'organization_subscription_banner_seatcount_limit_reached'
  | 'organization_subscription_banner_seatcount_near_limit'
  | 'organization_subscription_banner_seats_used'
  | 'organization_subscription_banner_subscription_expired'
  | 'organization_subscription_banner_subscription_expires_soon'
  | 'oura_teams_privacy_policy'
  | 'page_not_found_body'
  | 'page_not_found_title'
  | 'privacy_policy'
  | 'reset_password_button_submit'
  | 'reset_password_success_login_link'
  | 'reset_password_success_text'
  | 'reset_password_success_title'
  | 'reset_password_title'
  | 'support_access_rights_access_denied_title'
  | 'support_access_rights_access_granted_text'
  | 'support_access_rights_access_granted_title'
  | 'support_access_rights_approve_button'
  | 'support_access_rights_disclaimer'
  | 'support_access_rights_invalid_link_text'
  | 'support_access_rights_invalid_link_title'
  | 'support_access_rights_link_expired_text'
  | 'support_access_rights_link_expired_title'
  | 'support_access_rights_paragraph_1'
  | 'support_access_rights_paragraph_2'
  | 'support_access_rights_paragraph_3'
  | 'support_access_rights_reject_button'
  | 'support_access_rights_title'
  | 'tags_and_notes_not_available_update_app'
  | 'tags_and_notes_permission_denied'
  | 'tags_and_notes_permission_denied_instructions'
  | 'tags_and_notes_unable_to_fetch'
  | 'tags_header'
  | 'tags_no_tags_in_time_range'
  | 'tags_open_tags_from_date'
  | 'tags_summary_between_dates'
  | 'tags_summary_from_start'
  | 'teams_data_files_custom_daily_intro'
  | 'teams_data_files_custom_daily_title'
  | 'teams_data_files_custom_interval_intro'
  | 'teams_data_files_custom_interval_title'
  | 'teams_data_files_custom_intro'
  | 'teams_data_files_custom_title'
  | 'teams_data_files_group_intro'
  | 'teams_data_files_group_title'
  | 'teams_data_files_intro'
  | 'teams_data_files_label_data_type'
  | 'teams_data_files_label_data_type_tooltip'
  | 'teams_data_files_label_data_type_tooltip_teaser'
  | 'teams_data_files_label_data_types'
  | 'teams_data_files_label_date'
  | 'teams_data_files_label_member'
  | 'teams_data_files_label_members'
  | 'teams_data_files_max_files_warning'
  | 'teams_data_files_teaser_optin'
  | 'terms_and_conditions'
  | 'terms_and_privacy_policy_updated_submit_button'
  | 'terms_and_privacy_policy_updated_title'
  | 'terms_of_service'
  | 'terms_of_use'
  | 'top_navigation_my_account'
  | 'top_navigation_sign_out'
  | 'trends_add_chart'
  | 'trends_correlation_between_metrics'
  | 'trends_correlation_between_metrics_with_day_offset'
  | 'trends_correlation_minus_one_day'
  | 'trends_correlation_negative'
  | 'trends_correlation_none'
  | 'trends_correlation_offset'
  | 'trends_correlation_plus_one_day'
  | 'trends_correlation_positive'
  | 'trends_correlation_with_day_offset'
  | 'trends_correlation_with_metric_and_day_offset'
  | 'trends_date_pagination_next_days'
  | 'trends_date_pagination_previous_days'
  | 'trends_date_range_label'
  | 'trends_day_letters'
  | 'trends_metric_correlation_heading_correlation'
  | 'trends_metric_correlation_not_enough_data'
  | 'trends_metric_correlation_not_enough_data_explanation'
  | 'trends_metric_correlation_r'
  | 'trends_metric_correlation_the_previous_day'
  | 'trends_metric_correlation_the_same_day'
  | 'trends_metric_correlation_the_the_following_day'
  | 'trends_metric_correlation_unknown_correlation'
  | 'trends_metric_pearson_correlation_coefficient'
  | 'trends_metric_pearson_correlation_coefficient_text'
  | 'trends_moderate_correlation'
  | 'trends_no_correlation'
  | 'trends_select_metric'
  | 'trends_strong_correlation'
  | 'trends_trend_period_label'
  | 'trends_weak_correlation';

export type LocaleMessagesJson = Record<MessageKey, string>;
